// Unified event tracker: fires browser Pixel AND server CAPI with a shared event_id.
import { newEventId, trackMeta } from "./metaPixel";

const API = process.env.REACT_APP_BACKEND_URL;

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

/**
 * Fire the same event through browser Pixel and server CAPI.
 * @param {string} eventName - Meta standard event (PageView, ViewContent, InitiateCheckout, Purchase, ...)
 * @param {object} customData - custom_data payload
 * @param {object} opts - { eventId, email }
 */
export function trackAndSend(eventName, customData = {}, opts = {}) {
  const eventId = opts.eventId || newEventId();
  const email = opts.email;

  // Browser
  trackMeta(eventName, customData, eventId);

  // Server (fire-and-forget). Backend no-ops when CAPI creds are empty.
  if (API && typeof window !== "undefined") {
    const body = JSON.stringify({
      event_name: eventName,
      event_id: eventId,
      event_source_url: window.location.href,
      custom_data: customData,
      email: email || undefined,
      fbp: readCookie("_fbp"),
      fbc: readCookie("_fbc"),
    });
    const url = `${API}/api/meta/event`;
    // Use fetch (with credentials) so cookies + response are consistent.
    // sendBeacon skipped so we don't lose typed body headers.
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      credentials: "include",
      keepalive: true,
    }).catch(() => {});
  }
  return eventId;
}
